import { Page } from '@/core/architecture'

import { ConsoleMembershipEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMembershipEdit Page
 * Implemented as a practical sample.
 */
export const ConsoleMembershipEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleMembershipEditTemplate state={state} {...actions} />
}
